import { gql } from '@apollo/client';
const SET_SPECIFICATION_STATE_TO_PRODUCTION = gql `
  mutation SetModelSpecificationStateToProduction($modelSpecificationId: ID!) {
    setModelSpecificationStateToProduction(modelSpecificationId: $modelSpecificationId) {
      modelSpecification {
        id
        state
      }
    }
  }
`;
export default SET_SPECIFICATION_STATE_TO_PRODUCTION;
